<template>
  <v-card class="mx-auto" max-width="980">
    <div class="pa-5 d-flex align-center">
      <h2>{{ title }}</h2>

      <v-spacer />
      <v-btn color="primary" icon @click="close">
        <v-icon large color="primary">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-form class="form" ref="firstForm" v-model="firstValid" lazy-validation>
      <v-row class="pa-2 ma-2">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-text-field
            clearable
            outlined
            maxlength="45"
            v-model="currentUser.name"
            :rules="[rules.nameRules]"
            :label="'Nome'"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <v-select
            outlined
            :items="userlogged.type == 0 ? userType : userTypeAdmin"
            class="userType"
            v-model="currentUser.type"
            label="Categoria"
            item-text="label"
            item-value="value"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <v-text-field
            outlined
            v-model="currentUser.email"
            id="inputEmail"
            :rules="[rules.emailRules]"
            :label="'E-mail'"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <v-text-field
            outlined
            v-model="currentUser.email2"
            id="inputEmailConfirm"
            oncopy="return false"
            onpaste="return false"
            :rules="[
              rules.required,
              rules.emailRules,
              this.currentUser.email === this.currentUser.email2 ||
                'Os e-mails devem ser iguais.',
            ]"
            :label="'Confirmação de e-mail'"
            required
          ></v-text-field>
        </v-col>
        <!-- editar=true e Master mexe no ADMIN -->
        <v-col
          v-if="
            isEditing && userlogged.type == 1 && currentUser.type == 0
              ? false
              : true
          "
          cols="12"
          sm="6"
          md="6"
          lg="6"
        >
          <v-text-field
            outlined
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            counter
            @click:append="show1 = !show1"
            v-model="currentUser.password"
            :rules="[rules.passwordRules]"
            minlength="8"
            :label="'Senha'"
            required
          ></v-text-field>
        </v-col>

        <v-col
          v-if="
            isEditing && userlogged.type == 1 && currentUser.type == 0
              ? false
              : true
          "
          cols="12"
          sm="6"
          md="6"
          lg="6"
        >
          <v-text-field
            outlined
            :type="show2 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            counter
            @click:append="show2 = !show2"
            v-model="currentUser.password2"
            minlength="8"
            oncopy="return false"
            onpaste="return false"
            :rules="[
              rules.passwordRules,
              this.currentUser.password === this.currentUser.password2 ||
                'As senhas devem ser iguais.',
            ]"
            :label="'Confirmação de senha'"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <v-card-actions class="btns-down">
      <v-row class="d-flex justify-center pt-0 ma-0 pa-0">
        <v-col
          class="btns-down"
          style="display: inline-flex; align-items: center"
          cols="12"
          sm="6"
          md="6"
          lg="6"
        >
          <v-btn large color="#2D3038" class="white--text" @click="close">
            <span>Voltar</span>
          </v-btn>

          <v-btn
            class="white--text ma-3 pa-3"
            large
            color="normalred"
            :loading="loading"
            elevation="3"
            @click="submit()"
          >
            <span>Adicionar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
@media (max-width: 600px) {
  .select-type {
    width: 90% !important;
  }
}

.form {
  display: flex;
  justify-content: center;
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}

.label-details {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  margin: 0;
}

.details-text {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
}

.titulo-detail {
  color: black;
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 40px;
  font-weight: bold;
}

/* .select{
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 10px;
} */
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";

export default {
  props: {
    title: String,
    user: Object,
  },

  created() {
    this.userlogged = JSON.parse(localStorage.getItem("user"));
    this.currentUser = {
      name: "",
      email: "",
    };

    if (this.user.id) {
      this.isEditing = true;
      this.currentUser = {
        id: this.user.id,
        name: this.user.name,
        email: this.user.email,
        type: this.user.type,
        status: this.user.status,
      };
    }
  },

  data: () => ({
    userlogged: [],
    isEditing: false,
    userType: [
      { label: "Master", value: 0 },
      { label: "Administrador", value: 1 },
      { label: "Financeiro", value: 5 },
      { label: "Marketing", value: 6 },
      { label: "Gerencial", value: 7 },
      { label: "Imprimextec", value: 8 },
    ],
    userTypeAdmin: [
      // { label: "Master", value: 0 },
      { label: "Administrador", value: 1 },
    ],
    show1: false,
    show2: false,
    password: "Password",
    dialogKey: false,
    loading: false,
    currentUser: {},
    firstValid: true,
    error: false,

    filter: {
      page: 1,
      pageSize: 15,
      DocumentNumber: null,
      status: null,
      updated_at: null,
    },

    rules: {
      min: (v) => v.length >= 8 || "Minímo de 8 caracteres",
      passwordRules: (v) =>
        (v && v.length >= 8) || "A senha deve ter pelo menos 8 caracteres",

      nameRules: (v) =>
        (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",

      emailRules: (v) =>
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          v
        ) || "E-mail inválido.",

      required: (v) => !!v || "Campo requerido.",

      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
    },

    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],

    apiService: new ApiService(),
  }),

  methods: {
    async submit() {
      this.loading = true;
      const user = {
        Id: this.currentUser.id,
        Name: this.currentUser.name,
        Password: this.currentUser.password,
        Email: this.currentUser.email,
        Type: this.currentUser.type,
        Status: this.currentUser.status,
      };

      let url = "user/add";
      if (this.isEditing) {
        url = "user/edit";
      }

      if (this.$refs.firstForm.validate() && this.currentUser.type != null) {
        await this.apiService
          .post(url, user)
          .then((response) => {
            /*const tipo = user.Type == "1" ? "Admin" : "Master";
            let email = {
              Name: user.Name,
              To: user.Email,
              Subject: "Senha provisória IMPRIMAX Autoadesivos",
              Message: user.Password,
              Type: "usuário IMPRIMAX - " + tipo,
            };
            if (this.isEditing) {
              email = {
                Name: user.Name,
                To: user.Email,
                Subject: "IMPRIMAX - Alteração de cadastro",
                Message: `Olá, seu cadastro foi alterado recentemente.
                .Se você não está ciente dessa alteração, entre em contato com seu administrador.`,
                Type: "usuário IMPRIMAX - " + user.Type,
              };
            }
            this.sendEmailUser(email);*/
            this.close();
            if (this.isEditing) {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "Cadastro atualizado com sucesso!",
                message: "Seus dados foram atualizados",
                trace: null,
              });
            } else {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "Cadastro efetuado com sucesso!",
                message: "Bem vindo à IMPRIMAX!",
                trace: null,
              });
            }
            this.loading = false;
          })
          .catch((err) => {
            if (err.status != 403) {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "E-mail já registrado.",
                message: err.body.message,
                trace: null,
              });
            } else if (err.status == 403) {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Este usuário não tem autorização para concluir a ação.",
                message: err.body.message,
                trace: null,
              });
            }
            // this.deleteDialog = false;
          });
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });
      }
      this.loading = false;
    },

    async sendEmailUser(email) {
      await this.apiService
        .post("email/sendClient", email)
        .then((resp) => {
          if (this.isEditing) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "info",
              title: "Cadastro atualizado com sucesso!",
              message: "Seus dados foram atualizados",
              trace: null,
            });
          } else {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Cadastro efetuado com sucesso!",
              message: "Bem vindo à IMPRIMAX!",
              trace: null,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Confira se o e-mail realmente existe",
            message: "E-mail inválido para receber o e-mail de confirmação",
            trace: null,
          });

          this.loading = false;
        });
    },

    close() {
      this.$emit("close");
      this.loading = false;
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
